import { useNavigationContext } from '../../../contexts/NavigationContext';
import Navbar from '../common/navbar/Navbar';
import CircumstancePage from './Circumstance/CircumstancePage';
import ProjectPage from './Project/ProjectPage';
import Welcome from './Welcome';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <div className="flex flex-row h-screen w-screen">
      <div className="min-w-64 w-64">
        <Navbar />
      </div>
      <div className="w-full h-auto overflow-scroll">
        <ProjectPage isActive={navigationContext.acitveAppKey === 'prnaproject'} />
        <CircumstancePage isActive={navigationContext.acitveAppKey === 'prnacircumstance'} />
        <Welcome isActive={!navigationContext.acitveAppKey} />
      </div>
    </div>
  );
}

export default Home;
